import { render, staticRenderFns } from "./agentList.vue?vue&type=template&id=64676c9c&scoped=true&"
import script from "./agentList.vue?vue&type=script&lang=js&"
export * from "./agentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64676c9c",
  null
  
)

export default component.exports